import React, { useEffect } from "react";
import LoggedOutUserIcon from "../Shared/LoggedOutUserIcon";

interface ILoggedOutUser {
  onLogin: () => void;
  isDesktop: boolean;
}

const LoggedOutUser = ({ onLogin, isDesktop }: ILoggedOutUser) => (
  <button role="button"
    name="user"
    onClick={onLogin}
    aria-label="User Icon"
    className="relative flex justify-center items-center">
      {isDesktop ? "SIGN IN" : <LoggedOutUserIcon />}
  </button>
);

export default LoggedOutUser;
